(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrinho"]) return;
  try {
    
    ;(function () {
      var sec = document.querySelector('[data-carrinho-pagina]')
      if (!sec) return

      function dinheiro(centavos) {
        if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(centavos)
        return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',')
      }

      // ----- Cupom de desconto -----
      var cupomWrap = sec.querySelector('[data-cupom]')

      function renderCupom(cart) {
        var subtotalEl = sec.querySelector('[data-subtotal]')
        if (subtotalEl) subtotalEl.textContent = dinheiro(cart.total_price)
        if (!cupomWrap) return
        var formCupom = cupomWrap.querySelector('[data-cupom-form]')
        var aplicado = cupomWrap.querySelector('[data-cupom-aplicado]')
        var codigoEl = cupomWrap.querySelector('[data-cupom-codigo]')
        var economiaEl = cupomWrap.querySelector('[data-cupom-economia]')
        var apps = cart.cart_level_discount_applications || []
        var temDesconto = cart.total_discount > 0 || apps.length > 0
        if (temDesconto) {
          var codigo = ''
          if (apps.length && apps[0].title) codigo = apps[0].title
          if (!codigo) {
            var inputEl = cupomWrap.querySelector('[data-cupom-input]')
            codigo = inputEl ? inputEl.value.trim().toUpperCase() : ''
          }
          if (codigoEl) codigoEl.textContent = codigo
          if (economiaEl) economiaEl.textContent = (cupomWrap.getAttribute('data-texto-economia') || 'Você economizou') + ' ' + dinheiro(cart.total_discount)
          if (aplicado) aplicado.hidden = false
          if (formCupom) formCupom.hidden = true
        } else {
          if (aplicado) aplicado.hidden = true
          if (formCupom) formCupom.hidden = false
        }
      }

      function mensagemCupom(texto) {
        if (!cupomWrap) return
        var msg = cupomWrap.querySelector('[data-cupom-msg]')
        if (!msg) return
        msg.textContent = texto || ''
        msg.hidden = !texto
      }

      function chamarCupom(codigo) {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: codigo })
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status)
          return r.json()
        })
      }

      if (cupomWrap) {
        var cupomInput = cupomWrap.querySelector('[data-cupom-input]')
        var cupomBtn = cupomWrap.querySelector('[data-cupom-aplicar]')
        var cupomRemoverBtn = cupomWrap.querySelector('[data-cupom-remover]')

        var aplicarCupom = function () {
          var codigo = (cupomInput.value || '').trim()
          if (!codigo) return
          mensagemCupom('')
          cupomBtn.disabled = true
          chamarCupom(codigo)
            .then(function (cart) {
              cupomBtn.disabled = false
              var apps = cart.cart_level_discount_applications || []
              if (cart.total_discount > 0 || apps.length > 0) {
                renderCupom(cart)
                document.dispatchEvent(new CustomEvent('cart:updated'))
              } else {
                mensagemCupom(cupomWrap.getAttribute('data-texto-invalido'))
              }
            })
            .catch(function () {
              cupomBtn.disabled = false
              mensagemCupom(cupomWrap.getAttribute('data-texto-erro'))
            })
        }

        cupomBtn.addEventListener('click', aplicarCupom)
        cupomInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault()
            aplicarCupom()
          }
        })

        cupomRemoverBtn.addEventListener('click', function () {
          cupomRemoverBtn.disabled = true
          chamarCupom('')
            .then(function (cart) {
              cupomRemoverBtn.disabled = false
              cupomInput.value = ''
              mensagemCupom('')
              renderCupom(cart)
              document.dispatchEvent(new CustomEvent('cart:updated'))
            })
            .catch(function () {
              cupomRemoverBtn.disabled = false
              mensagemCupom(cupomWrap.getAttribute('data-texto-erro'))
            })
        })

        // Restaura o estado no load — /cart.js é a fonte da verdade
        // (só re-renderiza quando HÁ desconto, pra não piscar o estado default)
        fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json()
          })
          .then(function (cart) {
            var apps = cart.cart_level_discount_applications || []
            if (cart.total_discount > 0 || apps.length > 0) renderCupom(cart)
          })
          .catch(function () {})
      }

      function trackBeginCheckout() {
        if (!window.PetZemTrack) return
        var resumoEl = sec.querySelector('[data-carrinho-resumo]')
        if (!resumoEl) return
        try {
          var resumo = JSON.parse(resumoEl.textContent)
          if (!resumo.items || !resumo.items.length) return
          PetZemTrack.event('begin_checkout', resumo)
        } catch (e) {}
      }

      var checkoutBtn = sec.querySelector('[name="checkout"]')
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', trackBeginCheckout)
      }

      function mudar(key, quantity, linha) {
        sec.classList.add('atualizando')
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        })
          .then(function (r) {
            return r.json()
          })
          .then(function (cart) {
            sec.classList.remove('atualizando')
            // atualiza contador do header e drawer
            var countEl = document.querySelector('[data-carrinho-count]')
            if (countEl) {
              countEl.textContent = cart.item_count
              countEl.setAttribute('data-count', cart.item_count)
            }
            document.dispatchEvent(new CustomEvent('cart:updated'))

            if (cart.item_count === 0) {
              window.location.reload()
              return
            }

            if (quantity === 0 && linha) {
              linha.parentNode.removeChild(linha)
            } else if (linha) {
              var item = cart.items.filter(function (i) {
                return i.key === key
              })[0]
              if (item) {
                var totalEl = linha.querySelector('[data-linha-total]')
                if (totalEl) totalEl.textContent = dinheiro(item.original_line_price)
                var qtdEl = linha.querySelector('[data-qtd-input]')
                if (qtdEl) qtdEl.value = item.quantity
              }
            }
            renderCupom(cart)
          })
          .catch(function () {
            sec.classList.remove('atualizando')
            if (window.mostrarAlerta) mostrarAlerta('Não foi possível atualizar o carrinho.', 'negativo')
          })
      }

      sec.addEventListener('click', function (e) {
        var linha = e.target.closest('[data-item]')
        if (!linha) return
        var key = linha.getAttribute('data-key')
        var input = linha.querySelector('[data-qtd-input]')
        if (e.target.closest('[data-qtd-mais]')) {
          mudar(key, (parseInt(input.value, 10) || 1) + 1, linha)
        } else if (e.target.closest('[data-qtd-menos]')) {
          var nova = (parseInt(input.value, 10) || 1) - 1
          mudar(key, nova < 0 ? 0 : nova, linha)
        } else if (e.target.closest('[data-remover]')) {
          mudar(key, 0, linha)
        }
      })

      sec.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qtd-input]')
        if (!input) return
        var linha = input.closest('[data-item]')
        var q = parseInt(input.value, 10)
        if (isNaN(q) || q < 0) q = 0
        mudar(linha.getAttribute('data-key'), q, linha)
      })

      // sincroniza subtotal/cupom quando o drawer atualiza o carrinho
      // (ex.: item adicionado pelo cross-sell)
      // guard: se o drawer somou mais itens do que as linhas server-rendered
      // desta página mostram, a lista está dessincronizada — recarrega em vez
      // de só atualizar o subtotal (senão fica N linhas com subtotal de N+1)
      document.addEventListener('carrinho:atualizado', function (e) {
        if (!e.detail) return
        var linhas = sec.querySelectorAll('[data-item]')
        var somaQtd = 0
        linhas.forEach(function (linha) {
          var qtdEl = linha.querySelector('[data-qtd-input]')
          somaQtd += qtdEl ? parseInt(qtdEl.value, 10) || 0 : 0
        })
        if (linhas.length && e.detail.item_count > somaQtd) {
          window.location.reload()
          return
        }
        renderCupom(e.detail)
      })
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confianca"] && !Shopify.designMode) return;
  try {
    
    ;(function () {
      document.querySelectorAll('[data-confianca]').forEach(function (sec) {
        var track = sec.querySelector('[data-confianca-track]')
        var dotsWrap = sec.querySelector('[data-confianca-dots]')
        if (!track || !dotsWrap) return
        var itens = track.children
        var mqMobile = window.matchMedia('(max-width: 768px)')
        var mqMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
        var dots = []
        var idx = 0
        var timer = null

        function build() {
          dotsWrap.innerHTML = ''
          dots = []
          for (var i = 0; i < itens.length; i++) {
            var b = document.createElement('button')
            b.type = 'button'
            b.className = 'confianca__dot'
            b.setAttribute('aria-label', 'Ir para item ' + (i + 1))
            b.addEventListener(
              'click',
              (function (n) {
                return function () {
                  go(n)
                }
              })(i)
            )
            dotsWrap.appendChild(b)
            dots.push(b)
          }
        }
        function go(i) {
          idx = i
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })
          paint()
        }
        function paint() {
          for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('ativo', i === idx)
        }
        function next() {
          go((idx + 1) % itens.length)
        }
        function start() {
          stop()
          if (mqMobile.matches && !mqMotion.matches && itens.length > 1) timer = setInterval(next, 4500)
        }
        function stop() {
          if (timer) {
            clearInterval(timer)
            timer = null
          }
        }

        track.addEventListener(
          'scroll',
          function () {
            var i = Math.round(track.scrollLeft / track.clientWidth)
            if (i !== idx) {
              idx = i
              paint()
            }
          },
          { passive: true }
        )
        track.addEventListener('pointerdown', stop)
        track.addEventListener('touchend', start, { passive: true })

        function setup() {
          if (mqMobile.matches) {
            if (!dots.length) build()
            paint()
            start()
          } else {
            stop()
            dotsWrap.innerHTML = ''
            dots = []
          }
        }
        setup()
        mqMobile.addEventListener('change', setup)
      })
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["documento"]) return;
  try {
    
  ;(function () {
    var main = document.getElementById('doc-main')
    var toc = document.getElementById('doc-toc')
    if (!main || !toc) return
    var headings = main.querySelectorAll('h2, h3')
    if (!headings.length) {
      var sb = document.querySelector('.documento__sidebar')
      if (sb) sb.style.display = 'none'
      return
    }
    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'ds-' + i
      var a = document.createElement('a')
      a.href = '#' + h.id
      a.textContent = h.textContent
      a.dataset.level = h.tagName === 'H3' ? '3' : '2'
      a.addEventListener('click', function (e) {
        e.preventDefault()
        document.getElementById(h.id).scrollIntoView({ behavior: 'smooth', block: 'start' })
        toc.querySelectorAll('a').forEach(function (l) {
          l.classList.remove('ativo')
        })
        a.classList.add('ativo')
      })
      toc.appendChild(a)
    })
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var id = e.target.id
            toc.querySelectorAll('a').forEach(function (l) {
              l.classList.toggle('ativo', l.getAttribute('href') === '#' + id)
            })
          }
        })
      },
      { rootMargin: '-80px 0px -70% 0px' }
    )
    headings.forEach(function (h) {
      obs.observe(h)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var headerPrincipal = document.querySelector('[data-header-principal]')
    var menuToggle = document.querySelector('[data-menu-toggle]')
    var mobileMenu = document.querySelector('[data-mobile-menu]')

    if (headerPrincipal) {
      window.addEventListener(
        'scroll',
        function () {
          if (window.scrollY > 50) {
            headerPrincipal.classList.add('scrolled')
          } else {
            headerPrincipal.classList.remove('scrolled')
          }
        },
        { passive: true }
      )
    }

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        var ativo = mobileMenu.classList.toggle('ativo')
        menuToggle.setAttribute('aria-expanded', ativo ? 'true' : 'false')
        mobileMenu.setAttribute('aria-hidden', ativo ? 'false' : 'true')
        document.body.style.overflow = ativo ? 'hidden' : ''
      })

      mobileMenu.addEventListener('click', function (e) {
        if (e.target.closest('[data-menu-fechar]')) {
          mobileMenu.classList.remove('ativo')
          menuToggle.setAttribute('aria-expanded', 'false')
          mobileMenu.setAttribute('aria-hidden', 'true')
          document.body.style.overflow = ''
        }
      })

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('ativo')) {
          mobileMenu.classList.remove('ativo')
          menuToggle.setAttribute('aria-expanded', 'false')
          mobileMenu.setAttribute('aria-hidden', 'true')
          document.body.style.overflow = ''
        }
      })
    }

    var carrinhoCount = document.querySelector('[data-carrinho-count]')
    if (carrinhoCount) {
      var carrinhoBtn = carrinhoCount.closest('button')
      var update = function () {
        fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json()
          })
          .then(function (cart) {
            carrinhoCount.textContent = cart.item_count
            carrinhoCount.setAttribute('data-count', cart.item_count)
            if (carrinhoBtn) {
              var base = carrinhoBtn.getAttribute('data-carrinho-rotulo') || ''
              carrinhoBtn.setAttribute('aria-label', base + ', ' + cart.item_count)
            }
          })
          .catch(function () {})
      }
      document.addEventListener('cart:updated', update)
      document.addEventListener('cart:added', update)
      update()
    }

    var barraCarousel = document.querySelector('[data-barra-carousel]')
    if (barraCarousel) {
      var slides = barraCarousel.querySelectorAll('[data-barra-slide]')
      var idx = 0
      var duracao = parseInt(barraCarousel.getAttribute('data-duracao'), 10) * 1000 || 8000
      var carouselInterval
      function mostrarSlide(n) {
        slides.forEach(function (s, i) {
          s.classList.toggle('ativo', i === n)
        })
        idx = n
      }
      function proxSlide() {
        mostrarSlide((idx + 1) % slides.length)
      }
      function parar() {
        if (carouselInterval) clearInterval(carouselInterval)
      }
      function iniciar() {
        if (slides.length > 1) carouselInterval = setInterval(proxSlide, duracao)
      }
      barraCarousel.addEventListener('mouseenter', parar)
      barraCarousel.addEventListener('mouseleave', iniciar)
      iniciar()
    }

    var buscaWrap = document.querySelector('[data-busca]')
    if (buscaWrap) {
      var clsBase = buscaWrap.getAttribute('data-cls')
      var buscaInput = buscaWrap.querySelector('[data-busca-input]')
      var buscaPainel = buscaWrap.querySelector('[data-busca-painel]')
      var buscaForm = buscaWrap.querySelector('form')
      var buscaTimeout
      var destacado = -1
      var HIST_KEY = 'petzem:buscas-recentes'
      var MAX_HIST = 5

      var labels = {
        recentes: buscaWrap.getAttribute('data-label-recentes'),
        limpar: buscaWrap.getAttribute('data-label-limpar'),
        categorias: buscaWrap.getAttribute('data-label-categorias'),
        produtos: buscaWrap.getAttribute('data-label-produtos'),
        vertodos: buscaWrap.getAttribute('data-label-vertodos') || '',
        vazio: buscaWrap.getAttribute('data-sem-resultados')
      }
      var searchUrl = buscaWrap.getAttribute('data-search-url') || '/search'

      function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
        })
      }
      function linkBusca(termo) {
        return searchUrl + '?q=' + encodeURIComponent(termo)
      }
      function formatarPreco(valor) {
        var n = parseFloat(
          String(valor == null ? '' : valor)
            .replace(/[^\d.,]/g, '')
            .replace(',', '.')
        )
        if (isNaN(n)) return ''
        try {
          return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } catch (e) {
          return 'R$ ' + n.toFixed(2).replace('.', ',')
        }
      }

      function lerHist() {
        try {
          return JSON.parse(localStorage.getItem(HIST_KEY)) || []
        } catch (e) {
          return []
        }
      }
      function salvarHist(termo) {
        termo = (termo || '').trim()
        if (!termo) return
        var hist = lerHist().filter(function (t) {
          return t.toLowerCase() !== termo.toLowerCase()
        })
        hist.unshift(termo)
        try {
          localStorage.setItem(HIST_KEY, JSON.stringify(hist.slice(0, MAX_HIST)))
        } catch (e) {}
      }
      function limparHist() {
        try {
          localStorage.removeItem(HIST_KEY)
        } catch (e) {}
      }

      function abrirPainel() {
        buscaPainel.hidden = false
        buscaInput.setAttribute('aria-expanded', 'true')
      }
      function fecharPainel() {
        buscaPainel.hidden = true
        buscaInput.setAttribute('aria-expanded', 'false')
        destacado = -1
      }

      function itens() {
        return Array.prototype.slice.call(buscaPainel.querySelectorAll('[role="option"]'))
      }
      function marcar(i) {
        var lista = itens()
        lista.forEach(function (el) {
          el.classList.remove('destacado')
        })
        if (i >= 0 && lista[i]) {
          lista[i].classList.add('destacado')
          lista[i].scrollIntoView({ block: 'nearest' })
        }
        destacado = i
      }

      function renderRecentes() {
        var hist = lerHist()
        if (!hist.length) {
          fecharPainel()
          return
        }
        var itensHtml = hist
          .map(function (t) {
            return '<a class="' + clsBase + '__busca-recente" role="option" href="' + linkBusca(t) + '" data-termo="' + escapeHtml(t) + '">' + '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + '<span>' + escapeHtml(t) + '</span></a>'
          })
          .join('')
        buscaPainel.innerHTML = '<div class="' + clsBase + '__busca-secao">' + '<div class="' + clsBase + '__busca-secao-head">' + '<span class="' + clsBase + '__busca-secao-titulo">' + escapeHtml(labels.recentes) + '</span>' + '<button type="button" class="' + clsBase + '__busca-limpar" data-busca-limpar>' + escapeHtml(labels.limpar) + '</button>' + '</div>' + itensHtml + '</div>'
        marcar(-1)
        abrirPainel()
      }

      function renderResultados(termo, data) {
        var res = (data && data.resources && data.resources.results) || {}
        var produtos = (res.products || []).slice(0, 6)
        var colecoes = (res.collections || []).slice(0, 4)
        if (!produtos.length && !colecoes.length) {
          buscaPainel.innerHTML = '<p class="' + clsBase + '__busca-vazio">' + escapeHtml(labels.vazio) + '</p>'
          marcar(-1)
          abrirPainel()
          return
        }
        var html = ''
        if (colecoes.length) {
          html +=
            '<div class="' +
            clsBase +
            '__busca-secao">' +
            '<div class="' +
            clsBase +
            '__busca-secao-head"><span class="' +
            clsBase +
            '__busca-secao-titulo">' +
            escapeHtml(labels.categorias) +
            '</span></div>' +
            '<div class="' +
            clsBase +
            '__busca-chips">' +
            colecoes
              .map(function (c) {
                return '<a class="' + clsBase + '__busca-chip" role="option" href="' + c.url + '">' + escapeHtml(c.title) + '</a>'
              })
              .join('') +
            '</div></div>'
        }
        if (produtos.length) {
          html +=
            '<div class="' +
            clsBase +
            '__busca-secao">' +
            '<div class="' +
            clsBase +
            '__busca-secao-head"><span class="' +
            clsBase +
            '__busca-secao-titulo">' +
            escapeHtml(labels.produtos) +
            '</span></div>' +
            produtos
              .map(function (p) {
                return '<a class="' + clsBase + '__busca-produto" role="option" href="' + p.url + '">' + (p.image ? '<img class="' + clsBase + '__busca-produto-img" src="' + p.image + '" alt="" loading="lazy">' : '<span class="' + clsBase + '__busca-produto-img"></span>') + '<span class="' + clsBase + '__busca-produto-info">' + '<span class="' + clsBase + '__busca-produto-nome">' + escapeHtml(p.title) + '</span>' + '<span class="' + clsBase + '__busca-produto-preco">' + escapeHtml(formatarPreco(p.price)) + '</span>' + '</span></a>'
              })
              .join('') +
            '</div>'
        }
        var partesVer = (labels.vertodos || '').split('XTERMOX')
        html += '<a class="' + clsBase + '__busca-vertodos" role="option" href="' + linkBusca(termo) + '">' + escapeHtml(partesVer[0]) + '“' + escapeHtml(termo) + '”' + escapeHtml(partesVer[1] || '') + '</a>'
        buscaPainel.innerHTML = html
        marcar(-1)
        abrirPainel()
      }

      function buscar(termo) {
        fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(termo) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) {
            return r.json()
          })
          .then(function (data) {
            renderResultados(termo, data)
          })
          .catch(function () {})
      }

      buscaInput.addEventListener('focus', function () {
        if (this.value.trim().length < 2) renderRecentes()
      })

      buscaInput.addEventListener('input', function () {
        clearTimeout(buscaTimeout)
        var termo = this.value.trim()
        destacado = -1
        if (termo.length < 2) {
          renderRecentes()
          return
        }
        buscaTimeout = setTimeout(function () {
          buscar(termo)
        }, 300)
      })

      buscaInput.addEventListener('keydown', function (e) {
        var lista = itens()
        if (e.key === 'ArrowDown') {
          if (buscaPainel.hidden) {
            if (this.value.trim().length < 2) renderRecentes()
            return
          }
          e.preventDefault()
          marcar(Math.min(destacado + 1, lista.length - 1))
        } else if (e.key === 'ArrowUp') {
          if (buscaPainel.hidden) return
          e.preventDefault()
          marcar(Math.max(destacado - 1, 0))
        } else if (e.key === 'Enter') {
          if (destacado >= 0 && lista[destacado]) {
            e.preventDefault()
            salvarHist(this.value.trim())
            window.location.href = lista[destacado].getAttribute('href')
          } else {
            salvarHist(this.value.trim())
          }
        } else if (e.key === 'Escape') {
          fecharPainel()
        }
      })

      buscaForm.addEventListener('submit', function () {
        salvarHist(buscaInput.value.trim())
      })

      buscaPainel.addEventListener('click', function (e) {
        var limpar = e.target.closest('[data-busca-limpar]')
        if (limpar) {
          e.preventDefault()
          limparHist()
          fecharPainel()
          buscaInput.focus()
          return
        }
        var link = e.target.closest('[role="option"]')
        if (link) salvarHist(buscaInput.value.trim() || link.getAttribute('data-termo') || '')
      })

      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-busca]')) fecharPainel()
      })
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listagem-colecao"]) return;
  try {
    
    ;(function () {
      function init(sec) {
        if (sec.dataset.iniciado === 'true') return
        sec.dataset.iniciado = 'true'

        var form = sec.querySelector('[data-filtros-form]')
        var ehDesktop = function () {
          return window.matchMedia('(min-width: 1024px)').matches
        }

        // auto-submit no desktop ao mudar filtros/ordenação
        sec.querySelectorAll('[data-filtro-input], [data-ordenar]').forEach(function (el) {
          el.addEventListener('change', function () {
            if (el.hasAttribute('data-ordenar') || ehDesktop()) form.submit()
          })
        })
        sec.querySelectorAll('[data-filtro-preco]').forEach(function (el) {
          el.addEventListener('change', function () {
            if (ehDesktop()) form.submit()
          })
        })

        // drawer de filtros no mobile
        sec.querySelectorAll('[data-abrir-filtros]').forEach(function (b) {
          b.addEventListener('click', function () {
            sec.classList.add('filtros-abertos')
            document.body.style.overflow = 'hidden'
          })
        })
        sec.querySelectorAll('[data-fechar-filtros]').forEach(function (b) {
          b.addEventListener('click', function () {
            sec.classList.remove('filtros-abertos')
            document.body.style.overflow = ''
          })
        })

        // "ver mais" por filtro
        sec.querySelectorAll('[data-ver-mais]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var det = btn.closest('.listagem__filtro')
            if (!det) return
            det.querySelectorAll('[data-valor-extra]').forEach(function (li) {
              li.hidden = false
            })
            det.dataset.expandido = 'true'
            btn.style.display = 'none'
          })
        })

        // busca dentro de listas longas
        sec.querySelectorAll('[data-busca-filtro]').forEach(function (input) {
          var det = input.closest('.listagem__filtro')
          if (!det) return
          var itens = det.querySelectorAll('[data-valor-item]')
          var btnMais = det.querySelector('[data-ver-mais]')

          input.addEventListener('input', function () {
            var q = input.value.trim().toLowerCase()
            if (q === '') {
              // restaura o estado colapsado (a menos que já tenham expandido)
              var expandido = det.dataset.expandido === 'true'
              itens.forEach(function (li) {
                li.hidden = li.hasAttribute('data-valor-extra') && !expandido
              })
              if (btnMais && !expandido) btnMais.style.display = ''
              return
            }
            if (btnMais) btnMais.style.display = 'none'
            itens.forEach(function (li) {
              var label = li.getAttribute('data-valor-label') || ''
              li.hidden = label.indexOf(q) === -1
            })
          })
        })
      }

      function initAll(root) {
        ;(root || document).querySelectorAll('[data-listagem]').forEach(init)
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          initAll()
        })
      } else {
        initAll()
      }
      document.addEventListener('shopify:section:load', function (e) {
        initAll(e.target)
      })
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-promo"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var popup = document.querySelector('[data-popup-promo]')
    if (!popup) return

    var CHAVE = 'petzem-popup-promo-fechado'
    var dias = parseInt(popup.getAttribute('data-dias'), 10) || 1
    var atraso = parseInt(popup.getAttribute('data-atraso'), 10)
    if (isNaN(atraso)) atraso = 4
    var nome = popup.getAttribute('data-promo-nome') || 'Promoção'

    try {
      var fechadoEm = parseInt(localStorage.getItem(CHAVE), 10)
      if (fechadoEm && Date.now() - fechadoEm < dias * 86400000) return
    } catch (e) {}

    var fecharBtn = popup.querySelector('[data-popup-fechar-btn]')

    function abrir() {
      popup.hidden = false
      // força reflow pra transição de opacidade rodar (anti-flash: o delay já
      // garante que isso acontece bem depois do primeiro paint / pre-load)
      void popup.offsetWidth
      popup.classList.add('visivel')
      if (fecharBtn) fecharBtn.focus()
      if (typeof PetZemTrack !== 'undefined') PetZemTrack.event('view_promotion', { promotion_name: nome })
    }

    function fechar() {
      popup.classList.remove('visivel')
      popup.hidden = true
      try {
        localStorage.setItem(CHAVE, String(Date.now()))
      } catch (e) {}
      document.removeEventListener('keydown', aoTeclar)
    }

    function aoTeclar(e) {
      if (e.key === 'Escape' && !popup.hidden) fechar()
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-fechar-btn]') || e.target.closest('[data-popup-fechar]')) {
        fechar()
        return
      }
      var copiar = e.target.closest('[data-popup-copiar]')
      if (copiar) {
        var codigoEl = popup.querySelector('[data-popup-codigo]')
        var codigo = codigoEl ? codigoEl.textContent.trim() : ''
        if (codigo && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(codigo)
            .then(function () {
              if (typeof mostrarAlerta !== 'undefined') mostrarAlerta('Código copiado!', 'positivo')
            })
            .catch(function () {})
        }
        return
      }
      if (e.target.closest('[data-popup-cta]') && typeof PetZemTrack !== 'undefined') {
        PetZemTrack.event('select_promotion', { promotion_name: nome })
      }
    })

    document.addEventListener('keydown', aoTeclar)

    function agendar() {
      setTimeout(abrir, atraso * 1000)
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', agendar)
    } else {
      agendar()
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produto"]) return;
  try {
    
    ;(function () {
      function init(sec) {
        if (sec.dataset.iniciado === 'true') return
        sec.dataset.iniciado = 'true'

        // ----- Galeria -----
        var principal = sec.querySelector('[data-img-principal]')
        sec.querySelectorAll('[data-thumb]').forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            if (principal) {
              principal.removeAttribute('srcset')
              principal.src = thumb.getAttribute('data-img-grande')
            }
            sec.querySelectorAll('[data-thumb]').forEach(function (t) {
              t.classList.remove('ativa')
            })
            thumb.classList.add('ativa')
          })
        })

        // ----- Abas / accordion -----
        sec.querySelectorAll('[data-aba-cabeca]').forEach(function (cabeca) {
          cabeca.addEventListener('click', function () {
            var aberto = cabeca.getAttribute('aria-expanded') === 'true'
            var corpo = cabeca.nextElementSibling
            cabeca.setAttribute('aria-expanded', aberto ? 'false' : 'true')
            if (corpo) corpo.classList.toggle('aberta', !aberto)
          })
        })

        // ----- Quantidade -----
        var qtdInput = sec.querySelector('[data-qtd-input]')
        var menos = sec.querySelector('[data-qtd-menos]')
        var mais = sec.querySelector('[data-qtd-mais]')
        if (menos)
          menos.addEventListener('click', function () {
            var v = parseInt(qtdInput.value, 10) || 1
            if (v > 1) qtdInput.value = v - 1
          })
        if (mais)
          mais.addEventListener('click', function () {
            var v = parseInt(qtdInput.value, 10) || 1
            qtdInput.value = v + 1
          })

        // ----- Variantes -----
        var dadosEl = sec.querySelector('[data-variantes]')
        var variantes = dadosEl ? JSON.parse(dadosEl.textContent) : []
        var estoqueMapEl = sec.querySelector('[data-estoque-variantes]')
        var estoqueMap = {}
        if (estoqueMapEl) {
          try {
            estoqueMap = JSON.parse(estoqueMapEl.textContent)
          } catch (e) {}
        }
        var limiteEstoque = parseInt(sec.getAttribute('data-limite-estoque'), 10) || 5
        var estoqueEl = sec.querySelector('[data-estoque-baixo]')
        var aviseEl = sec.querySelector('[data-avise-me]')

        function atualizarDisponibilidade(variante) {
          if (estoqueEl) {
            var qtd = estoqueMap[String(variante.id)]
            var mostra = !!variante.available && typeof qtd === 'number' && qtd > 0 && qtd <= limiteEstoque
            if (mostra) {
              estoqueEl.textContent = qtd === 1 ? estoqueEl.getAttribute('data-texto-ultima') : (estoqueEl.getAttribute('data-texto-baixo') || '').replace('[qtd]', qtd)
            } else {
              estoqueEl.textContent = ''
            }
            estoqueEl.hidden = !mostra
          }
          if (aviseEl) {
            if (variante.available) {
              aviseEl.hidden = true
            } else {
              var tituloProduto = aviseEl.getAttribute('data-produto-titulo') || ''
              var sufixoVariante = variante.title && variante.title !== 'Default Title' ? ' (' + variante.title + ')' : ''
              var msg = 'Olá! Quero saber quando *' + tituloProduto + sufixoVariante + '* voltar ao estoque 🐾'
              aviseEl.setAttribute('href', 'https://wa.me/' + aviseEl.getAttribute('data-wpp') + '?text=' + encodeURIComponent(msg))
              aviseEl.hidden = false
            }
          }
        }
        var idInput = sec.querySelector('[data-variante-id]')
        var precoEl = sec.querySelector('[data-preco]')
        var precoAntigoEl = sec.querySelector('[data-preco-antigo]')
        var economiaEl = sec.querySelector('[data-economia]')
        var addBtn = sec.querySelector('[data-add-carrinho]')
        var addTexto = sec.querySelector('[data-add-texto]')
        var barraPreco = sec.querySelector('[data-barra-preco]')
        var barraAdd = sec.querySelector('[data-barra-add]')
        var barraTexto = sec.querySelector('[data-barra-texto]')

        function dinheiro(centavos) {
          if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(centavos)
          return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',')
        }

        var parcelaEl = sec.querySelector('[data-parcela]')

        function atualizarParcela(variante) {
          if (!parcelaEl) return
          var prefixo = parcelaEl.getAttribute('data-prefixo') || ''
          var sufixo = parcelaEl.getAttribute('data-sufixo') || ''
          if (variante.price >= 3000) {
            parcelaEl.innerHTML = prefixo + ' <strong>6x de ' + dinheiro(variante.price / 6) + '</strong> sem juros ' + sufixo
          } else {
            parcelaEl.innerHTML = prefixo + ' <strong>' + (parcelaEl.getAttribute('data-destaque') || '6x sem juros') + '</strong> ' + sufixo
          }
        }

        function selecionarVariante() {
          var inputs = sec.querySelectorAll('[data-opcao-input]:checked')
          if (!inputs.length) return
          var escolhidas = []
          inputs.forEach(function (i) {
            escolhidas.push(i.value)
          })
          var encontrada = variantes.find(function (v) {
            return escolhidas.every(function (val, idx) {
              return v.options[idx] === val
            })
          })
          if (!encontrada) return
          idInput.value = encontrada.id
          var promo = encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price
          if (precoEl) {
            precoEl.textContent = dinheiro(encontrada.price)
            precoEl.classList.toggle('produto__preco--promo', !!promo)
          }
          if (precoAntigoEl) {
            if (promo) {
              precoAntigoEl.textContent = dinheiro(encontrada.compare_at_price)
              precoAntigoEl.style.display = ''
            } else {
              precoAntigoEl.style.display = 'none'
            }
          }
          if (economiaEl) {
            if (promo) {
              economiaEl.textContent = (form.getAttribute('data-msg-economia') || 'Você economiza') + ' ' + dinheiro(encontrada.compare_at_price - encontrada.price)
              economiaEl.hidden = false
            } else {
              economiaEl.hidden = true
            }
          }
          if (barraPreco) barraPreco.textContent = dinheiro(encontrada.price)
          atualizarParcela(encontrada)
          var textoBtn = encontrada.available ? (addBtn ? addBtn.getAttribute('data-texto-add') : 'Adicionar') : addBtn ? addBtn.getAttribute('data-texto-esgotado') : 'Esgotado'
          if (addBtn) {
            addBtn.disabled = !encontrada.available
            if (addTexto) addTexto.textContent = textoBtn
          }
          if (barraAdd) barraAdd.disabled = !encontrada.available
          if (barraTexto) barraTexto.textContent = textoBtn
          atualizarDisponibilidade(encontrada)
          // imagem da variante
          if (encontrada.featured_image && principal) {
            principal.removeAttribute('srcset')
            principal.src = encontrada.featured_image.src
          }
        }

        sec.querySelectorAll('[data-opcao-input]').forEach(function (input) {
          input.addEventListener('change', selecionarVariante)
        })

        // ----- Adicionar ao carrinho -----
        var form = sec.querySelector('[data-produto-form]')
        if (form) {
          form.addEventListener('submit', function (e) {
            e.preventDefault()
            if (addBtn && addBtn.disabled) return
            var id = idInput.value
            var qtd = parseInt(qtdInput.value, 10) || 1
            if (addBtn) addBtn.classList.add('carregando')
            var textoOriginal = addTexto ? addTexto.textContent : ''
            if (addTexto) addTexto.textContent = form.getAttribute('data-msg-adicionando') || 'Adicionando...'

            function finalizar() {
              if (addBtn) addBtn.classList.remove('carregando')
              if (addTexto) addTexto.textContent = textoOriginal
            }

            if (window.PetZemCarrinho && PetZemCarrinho.adicionar) {
              PetZemCarrinho.adicionar(id, qtd)
                .then(function () {
                  finalizar()
                  if (window.mostrarAlerta) mostrarAlerta(form.getAttribute('data-msg-sucesso') || 'Produto adicionado ao carrinho!', 'positivo')
                })
                .catch(function () {
                  finalizar()
                  if (window.mostrarAlerta) mostrarAlerta(form.getAttribute('data-msg-erro') || 'Não foi possível adicionar. Tente novamente.', 'negativo')
                })
            } else {
              // fallback: envia para a página de carrinho
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: id, quantity: qtd })
              })
                .then(function () {
                  window.location.href = window.Shopify.routes.root + 'cart'
                })
                .catch(finalizar)
            }
          })
        }

        // ----- Barra de compra fixa (mobile) -----
        var barra = sec.querySelector('[data-barra-compra]')
        if (barra && barraAdd && form) {
          barraAdd.addEventListener('click', function () {
            if (addBtn) addBtn.click()
          })
          var ancora = sec.querySelector('.produto__compra')
          if (ancora && 'IntersectionObserver' in window) {
            var obs = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  // mostra a barra quando o botão principal saiu acima da viewport
                  var passouDoTopo = entry.boundingClientRect.top < 0
                  barra.classList.toggle('visivel', !entry.isIntersecting && passouDoTopo)
                  barra.setAttribute('aria-hidden', !entry.isIntersecting && passouDoTopo ? 'false' : 'true')
                })
              },
              { threshold: 0 }
            )
            obs.observe(ancora)
          }
        }

        // ----- Produtos relacionados (lazy via Recommendations API) -----
        var rec = sec.querySelector('[data-relacionados]')
        if (rec && !rec.querySelector('.produto__relacionados-grid')) {
          var url = rec.getAttribute('data-url')
          fetch(url)
            .then(function (r) {
              return r.text()
            })
            .then(function (html) {
              var temp = document.createElement('div')
              temp.innerHTML = html
              var bloco = temp.querySelector('[data-relacionados]')
              if (bloco && bloco.querySelector('.produto__relacionados-grid')) rec.innerHTML = bloco.innerHTML
            })
            .catch(function () {})
        }
      }

      function initAll(root) {
        ;(root || document).querySelectorAll('[data-produto-section]').forEach(init)
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          initAll()
        })
      } else {
        initAll()
      }
      document.addEventListener('shopify:section:load', function (e) {
        initAll(e.target)
      })
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produtos"] && !Shopify.designMode) return;
  try {
    
    ;(function () {
      function initAbas(sec) {
        if (sec.dataset.iniciado === 'true') return
        sec.dataset.iniciado = 'true'
        var abas = sec.querySelectorAll('[data-aba]')
        var paineis = sec.querySelectorAll('[data-painel]')
        abas.forEach(function (aba) {
          aba.addEventListener('click', function () {
            var i = aba.getAttribute('data-aba')
            abas.forEach(function (a) {
              var on = a.getAttribute('data-aba') === i
              a.classList.toggle('ativa', on)
              a.setAttribute('aria-selected', on ? 'true' : 'false')
            })
            paineis.forEach(function (p) {
              p.classList.toggle('ativo', p.getAttribute('data-painel') === i)
            })
          })
        })
        paineis.forEach(function (painel) {
          var grid = painel.querySelector('.produtos__grid')
          if (!grid) return
          var prev = painel.querySelector('[data-prod-prev]')
          var next = painel.querySelector('[data-prod-next]')
          function step(dir) {
            grid.scrollBy({ left: dir * grid.clientWidth * 0.86, behavior: 'smooth' })
          }
          if (prev)
            prev.addEventListener('click', function () {
              step(-1)
            })
          if (next)
            next.addEventListener('click', function () {
              step(1)
            })
        })
      }
      function initAll(root) {
        ;(root || document).querySelectorAll('[data-produtos]').forEach(initAbas)
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          initAll()
        })
      } else {
        initAll()
      }
      document.addEventListener('shopify:section:load', function (e) {
        initAll(e.target)
      })
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    function initSlideshow(slideshow) {
      if (slideshow.dataset.iniciado === 'true') return
      var slides = slideshow.querySelectorAll('[data-slide-index]')
      if (!slides.length) return
      slideshow.dataset.iniciado = 'true'

      var bullets = slideshow.querySelectorAll('[data-bullet]')
      var prev = slideshow.querySelector('[data-slideshow-prev]')
      var next = slideshow.querySelector('[data-slideshow-next]')
      var current = 0
      var transitioning = false
      var FADE_MS = 850
      var autoplay = slideshow.getAttribute('data-autoplay') === 'true'
      var duracao = parseInt(slideshow.getAttribute('data-duracao'), 10) || 8000
      var intervalId
      var rafId = null
      var pendingTimeout = null

      function clearRaf() {
        if (rafId) {
          cancelAnimationFrame(rafId)
          rafId = null
        }
      }

      function show(idx) {
        if (idx === current || transitioning) return
        transitioning = true

        var saindo = slides[current]
        var entrando = slides[idx]

        saindo.style.cssText = 'display:flex;position:absolute;inset:0;z-index:10;pointer-events:none;opacity:1;transition:opacity ' + FADE_MS + 'ms cubic-bezier(0.4,0,0.2,1)'
        entrando.classList.add('ativo')

        clearRaf()
        rafId = requestAnimationFrame(function () {
          rafId = requestAnimationFrame(function () {
            rafId = null
            saindo.style.opacity = '0'
          })
        })

        bullets.forEach(function (b, i) {
          b.classList.toggle('ativo', i === idx)
        })
        current = idx

        var painelAtivo = entrando.querySelector('[style*="--cor-painel"]')
        if (painelAtivo) {
          var cor = painelAtivo.style.getPropertyValue('--cor-painel').trim()
          if (cor) slideshow.style.setProperty('--cor-painel-ativo', cor)
        }

        pendingTimeout = setTimeout(function () {
          pendingTimeout = null
          saindo.classList.remove('ativo')
          saindo.style.cssText = ''
          transitioning = false
        }, FADE_MS + 50)
      }

      function reconciliar() {
        clearRaf()
        if (pendingTimeout) {
          clearTimeout(pendingTimeout)
          pendingTimeout = null
        }
        ;[].forEach.call(slides, function (s, i) {
          s.style.cssText = ''
          s.classList.toggle('ativo', i === current)
        })
        bullets.forEach(function (b, i) {
          b.classList.toggle('ativo', i === current)
        })
        transitioning = false
        var painelAtivo = slides[current].querySelector('[style*="--cor-painel"]')
        if (painelAtivo) {
          var cor = painelAtivo.style.getPropertyValue('--cor-painel').trim()
          if (cor) slideshow.style.setProperty('--cor-painel-ativo', cor)
        }
      }
      function nextSlide() {
        show((current + 1) % slides.length)
      }
      function prevSlide() {
        show((current - 1 + slides.length) % slides.length)
      }
      function startAuto() {
        stopAuto()
        if (autoplay && slides.length > 1) intervalId = setInterval(nextSlide, duracao)
      }
      function stopAuto() {
        if (intervalId) {
          clearInterval(intervalId)
          intervalId = null
        }
      }

      if (next)
        next.addEventListener('click', function () {
          stopAuto()
          nextSlide()
          startAuto()
        })
      if (prev)
        prev.addEventListener('click', function () {
          stopAuto()
          prevSlide()
          startAuto()
        })

      ;[].forEach.call(bullets, function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault()
          stopAuto()
          show(parseInt(b.getAttribute('data-bullet'), 10))
          startAuto()
        })
      })

      slideshow.addEventListener('mouseenter', stopAuto)
      slideshow.addEventListener('mouseleave', startAuto)

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAuto()
        } else {
          reconciliar()
          startAuto()
        }
      })

      var touchStartX = 0
      slideshow.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.touches[0].clientX
        },
        { passive: true }
      )
      slideshow.addEventListener(
        'touchend',
        function (e) {
          var diff = touchStartX - e.changedTouches[0].clientX
          if (Math.abs(diff) > 50) {
            stopAuto()
            if (diff > 0) nextSlide()
            else prevSlide()
            startAuto()
          }
        },
        { passive: true }
      )

      startAuto()
    }

    function initAll(root) {
      ;(root || document).querySelectorAll('[data-slideshow]').forEach(initSlideshow)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll()
      })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target)
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
